import { defineStore } from "pinia";
import constants from "@/constant";
import type { DashboardApp } from "@/types/common";

export const useDashboardAppStore = defineStore("dashboardApp", {
  state: () => ({
    selectedApp: constants.DASHBOARD_APPS.RIKTIGA_VYKORT as DashboardApp,
  }),
  actions: {
    setSelectedApp(app: DashboardApp) {
      this.selectedApp = app;
    },
  },
});
